export const menuItems = [
  {
    id: '1',
    name: 'Burger Classique',
    description: 'Bœuf, salade, tomate, oignon, sauce maison',
    price: 12.99,
    image: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=500',
    category: 'burgers',
    available: true,
    customizations: [
      {
        id: 'cooking',
        name: 'Cuisson',
        required: true,
        multiple: false,
        options: [
          { id: 'rare', name: 'Saignant', price: 0 },
          { id: 'medium', name: 'À point', price: 0 },
          { id: 'well-done', name: 'Bien cuit', price: 0 }
        ]
      },
      {
        id: 'extras',
        name: 'Suppléments',
        required: false,
        multiple: true,
        options: [
          { id: 'cheese', name: 'Fromage', price: 1 },
          { id: 'bacon', name: 'Bacon', price: 2 },
          { id: 'egg', name: 'Œuf', price: 1.5 }
        ]
      }
    ]
  },
  {
    id: '2',
    name: 'Salade César',
    description: 'Laitue romaine, parmesan, croûtons, sauce césar',
    price: 9.99,
    image: 'https://images.unsplash.com/photo-1550304943-4f24f54ddde9?w=500',
    category: 'salades',
    available: true
  }
];